import { createFileRoute } from '@tanstack/react-router';

import { redirectToCodebaseSettings } from '@/utils/codebaseUrl';

// Overview was folded into the codebase Settings tab (its About column now
// lives there).
export const Route = createFileRoute('/$organizationName/cb/$codebaseId/overview/$')({
  component: () => null,
  beforeLoad: ({ params, search }) => {
    throw redirectToCodebaseSettings(params, search);
  },
});
